import { createAction } from 'redux-actions';
import { PageType, PageTypeState } from '../../types/pageType';

const SET_PAGETYPE = 'SET_PAGETYPE';
export const setPageType = createAction(
  SET_PAGETYPE,
  (pageType: PageType) => ({ pageType } as PageTypeState)
);
